import { render, staticRenderFns } from "./CustomerPortalPersonalInfo.vue?vue&type=template&id=3a5f2533&scoped=true&"
import script from "./CustomerPortalPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalPersonalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5f2533",
  null
  
)

export default component.exports